export default __webpack_public_path__ + "static/media/algodao_c3_a_c8.8101fe3e.png";